// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___5E5Y4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-redirect/style.css
// module id = 1241
// module chunks = 0